/**
 * Class render zoom component
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 11:00
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.ZoomSlider = Greenmile.Toolbar.Map.ZoomSlider || {};

Greenmile.Toolbar.Map.ZoomSlider = function (selector, map) {

    this.selector = selector;
    this.map = map;

    this.setActived = function (a) {
        this.actived = a;
    };

    this.addListeners = function () {

        this.map.on("zoomend", function (e) {
            $(selector + " .mapZoomRange").slider("value", e.target._zoom);
        });

        this.map.on("layeradd", (e) => {
            Greenmile.Map.Utility.adjustZoom(e, selector);
        });

        $(selector + " .mapZoomRange").slider({
            value: map.getZoom(),
            min: map.getMinZoom(),
            max: map.getMaxZoom(),
            step: 1,
            slide: function (event, ui) {

                // TODO
                map.setZoom(ui.value);

            }
        });

        $(selector + " .zoomOut").off("click");

        $(selector + " .zoomOut").on("click", function () {

            $(selector + " .mapZoomRange").slider("value",
                $(selector + " .mapZoomRange").slider("value") - 1);

            // TODO melhorar essa chamada
            map.setZoom($(selector + " .mapZoomRange").slider("value"));

        });

        $(selector + " .zoomIn").off("click");

        $(selector + " .zoomIn").on(
            "click",
            function () {

                $(selector + " .mapZoomRange").slider(
                    "value",
                    $(selector + " .mapZoomRange")
                        .slider("value") + 1);

                // TODO melhorar essa chamada
                map.setZoom($(selector + " .mapZoomRange").slider(
                    "value"));

            });

    };

    var init = function () {

        return function () {

        };
    };

    init(this);

};
